'use strict'

export default class ToolkitNavigation {
    constructor(element) {
        this.root = element;
        this.links = this.root.querySelectorAll('[js-data="toolkit-section"]');
        this.linksContent = this.root.querySelectorAll('[js-data="toolkit-section-content"]');

        this.bindEvents();
    }

    openSubNav(e) {
        e.preventDefault();
        let linkClicked = e.currentTarget;
        let linkNumber = linkClicked.getAttribute('js-data-number');
        let listItem = linkClicked.parentNode;

        linkClicked.blur();

        if (!listItem.classList.contains('active')) {
            this.root.querySelector('.toolkit--second-level li.active').classList.remove('active');
            listItem.classList.add('active');

            for (let j = 0; j < this.linksContent.length; j++) {
                const element = this.linksContent[j];

                if (element.classList.contains('hidden-section')) {
                    if (element.getAttribute('js-data-number') === linkNumber) {
                        element.classList.remove('hidden-section');

                        // For keyboard navigaion to land on first item of submenu
                        listItem.parentNode.querySelector('li:last-child a').focus();
                        listItem.parentNode.querySelector('li:last-child a').blur();
                    }
                } else {
                    element.classList.add('hidden-section');
                }
            }
        }
    }
    
    bindEvents() {  
        
        for (let i = 0; i < this.links.length; i++) {
            let link = this.links[i];

            link.addEventListener('click', this.openSubNav.bind(this));            
        }
    }
}